<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-select
      v-model="localStep.entity_from"
      placeholder="Take entity from"
      @change="(changedValue) => getEntityDetails(changedValue, localStep)"
      clearable
      filterable
    >
      <el-option-group label="Relational"></el-option-group>
      <el-option-group label="Entity fields">
        <el-option
          v-for="(field, i) in getFieldsByType(['ENTITY'], allFieldsWithDataTable)"
          :key="field + i"
          :value="field.key"
          :label="field.label"
        ></el-option>
      </el-option-group>
    </el-select>
    <el-select
      v-if="localStep.entity_id"
      v-model="localStep.update_field"
      placeholder="Update field"
      clearable
      filterable
      @change="(changedValue) => setField(changedValue)"
    >
      <el-option
        v-for="(field, i) in actionEntityFields[localStep.entity_id]"
        :key="field + i"
        :value="field.key"
        :label="field.label"
      ></el-option>
    </el-select>
    <el-select
      v-if="localStep.input_type == 'DATA_TABLE' && localStep.update_field"
      v-model="localStep.data_table_column_update_field_match"
      placeholder="Match with"
      multiple
    >
      <el-option
        v-for="(field, i) in getFieldProperty(
          actionEntityFields[localStep.entity_id],
          localStep.update_field,
          'key',
          'data_table_columns'
        )"
        :key="field + i"
        :value="field.key"
        :label="field.label"
      ></el-option>
    </el-select>
    <el-tooltip
      v-if="localStep.entity_from && localStep.input_type == 'DATA_TABLE' && localStep.update_field"
      class="item"
      effect="dark"
      content="Allow Create new data if existed data not found"
      placement="top-start"
    >
      <el-checkbox
        class="mt-1"
        v-model="localStep.create_new_data"
        v-if="
          localStep.entity_from && localStep.input_type == 'DATA_TABLE' && localStep.update_field
        "
      ></el-checkbox>
    </el-tooltip>
    <el-select
      v-if="
        localStep.input_type == 'DATA_TABLE' &&
        localStep.update_field &&
        localStep.data_table_column_update_field_match &&
        localStep.data_table_column_update_field_match.length
      "
      v-model="localStep.data_table_column_update_field"
      placeholder="Update table field"
    >
      <el-option
        v-for="(field, i) in (
          getFieldProperty(
            actionEntityFields[localStep.entity_id],
            localStep.update_field,
            'key',
            'data_table_columns'
          ) || []
        ).filter(
          (e) => (localStep.data_table_column_update_field_match || []).indexOf(e.key) == -1
        )"
        :key="field + i"
        :value="field.key"
        :label="field.label"
      ></el-option>
    </el-select>
    <el-select
      v-if="localStep.update_field"
      v-model="localStep.operator"
      placeholder="Operator"
      clearable
      filterable
    >
      <template
        v-if="
          operators[getFieldInputType(localStep)] && operators[getFieldInputType(localStep)].length
        "
      >
        <el-option
          v-for="(field, i) in operators[getFieldInputType(localStep)]"
          :key="field + i"
          :value="field.key"
          :label="field.label"
        ></el-option>
      </template>
      <el-option
        value="ADD_ROW"
        label="Add Row (+)"
        v-else-if="localStep.input_type == 'DATA_TABLE'"
      ></el-option>
      <el-option value="=" label="Value (=)"></el-option>
    </el-select>
    <div
      v-if="
        localStep.operator &&
        localStep.keyIndex != stepRefreshIndex &&
        actionEntityFields[localStep.entity_id] &&
        !['GENERATE_NEW_NUMBER', 'ADD_ROW'].includes(localStep.operator)
      "
    >
      <div v-if="localStep.input_type == 'DATA_TABLE'">
        <span
          v-if="
            getMappedField(
              getFieldProperty(
                actionEntityFields[localStep.entity_id],
                localStep.update_field,
                'key',
                'data_table_columns'
              ) || [],
              localStep.data_table_column_update_field,
              'key'
            )
          "
        >
          <AnyFieldsExecute
            :fieldsData="
              getFieldProperty(
                actionEntityFields[localStep.entity_id],
                localStep.update_field,
                'key',
                'data_table_columns'
              ) || []
            "
            :field="
              getMappedField(
                getFieldProperty(
                  actionEntityFields[localStep.entity_id],
                  localStep.update_field,
                  'key',
                  'data_table_columns'
                ) || [],
                localStep.data_table_column_update_field,
                'key'
              )
            "
            :form="localStep"
          ></AnyFieldsExecute>
        </span>
      </div>
      <div
        v-else-if="
          getMappedField(actionEntityFields[localStep.entity_id], localStep.update_field, 'key')
        "
      >
        <AnyFieldsExecute
          v-if="
            getMappedField(actionEntityFields[localStep.entity_id], localStep.update_field, 'key')
          "
          :fieldsData="actionEntityFields[localStep.entity_id]"
          :field="
            getMappedField(actionEntityFields[localStep.entity_id], localStep.update_field, 'key')
          "
          :form="localStep"
        ></AnyFieldsExecute>
      </div>
      <el-input
        v-else
        v-model="localStep.value"
        clearable
        :disabled="localStep.value_field ? true : false"
        :type="getFieldInputType(localStep) == 'NUMBER' ? 'number' : 'text'"
      ></el-input>
    </div>
    <div
      style="text-align: center !important; padding-top: 3px"
      v-if="localStep.operator && !['GENERATE_NEW_NUMBER', 'ADD_ROW'].includes(localStep.operator)"
    >
      <span>OR</span>
    </div>
    <el-select
      v-if="localStep.operator && !['GENERATE_NEW_NUMBER', 'ADD_ROW'].includes(localStep.operator)"
      v-model="localStep.value_field"
      placeholder="Update with"
      clearable
      filterable
      :disabled="
        (localStep.value && typeof localStep.value !== 'object') ||
        (localStep.value && typeof localStep.value == 'object' && localStep.value.length)
          ? true
          : false
      "
      @change="(changedValue) => setValueField(changedValue, localStep, allFields)"
    >
      <el-option
        v-for="(field, i) in getFieldsByType([getFieldInputType(localStep)], allFields)"
        :key="field + i"
        :value="
          field.data_table_key
            ? field.key.includes(':')
              ? field.data_table_key + '/' + field.key.split(':')[1]
              : field.data_table_key + '/' + field.key
            : field.key
        "
        :label="field.label"
      ></el-option>
    </el-select>
    <el-button
      v-if="localStep.operator == 'ADD_ROW'"
      type="text"
      icon="el-icon-s-tools"
      @click="openDTableModal()"
    >
      Configure
    </el-button>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :visible="mapDataTableFieldsModal"
      :title="'Map Data table Fields'"
      @before-close="mapDataTableFieldsModal = false"
      :containerWidth="'30%'"
      :containerHeight="'auto'"
    >
      <el-table :data="dataTableMappingFields">
        <el-table-column label="Field" prop="label"></el-table-column>
        <el-table-column label="Mapped with" prop="key" width="250">
          <template slot-scope="scope">
            <div class="d-flex">
              <el-select
                v-model="dataTableMapping['mapped/' + scope.row.key]"
                placeholder="Update with"
                clearable
                filterable
                :disabled="
                  dataTableMapping[scope.row.key] && dataTableMapping[scope.row.key].length
                    ? true
                    : false
                "
              >
                <el-option
                  v-for="(field, i) in fetchTemplateFieldsByType(
                    [scope.row.inputType],
                    allFieldsWithDataTable,
                    scope.row.entity_id,
                    scope.row.key
                  )"
                  :key="field + i"
                  :value="field.key"
                  :label="field.label"
                  :disabled="tableFieldDisabled(field)"
                ></el-option>
                <el-option
                  v-if="
                    scope.row.input_type == 'ENTITY' && scope.row.entity_id == currentEntity._id
                  "
                  :label="
                    'Current ' +
                    (currentEntity && currentEntity.name ? currentEntity.name : 'entity')
                  "
                  value="currentEntityData"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mapDataTableFieldsModal = false">Close</el-button>
        <el-button type="primary" @click="saveDataTableConfig">Save</el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  export default {
    name: 'OtherUpdateAction',
    props: {
      step: Object,
      allFields: Array,
      currentEntity: Object,
      allEntities: Array,
    },
    data() {
      return {
        allFieldsWithDataTable: [],
        dataTableMapping: {},
        mapDataTableFieldsModal: false,
        dataTableMappingFields: [],
      };
    },
    mixins: [StepEditableMixin, templateBuilderHelper],
    components: {
      AnyFieldsExecute: () =>
        import('@/components/templates/formComponentsExecute/AnyFieldsExecute.vue'),
    },
    computed: {
      entityFields() {
        return this.getFieldsByType(['ENTITY'], this.allFields);
      },
    },
    mounted() {
      this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
        this.currentEntity,
        true,
        true,
        true
      );
      (this.allEntities || []).forEach((entity) => {
        this.actionEntityFields[entity._id] = this.getAllFieldsFromEntity(
          entity,
          false,
          false,
          true
        );
      });
    },
    methods: {
      setField(key) {
        let fields = this.actionEntityFields[this.localStep.entity_id] || [];
        if (key) {
          let field = fields.find((e) => e.key == key);
          this.stepRefreshIndex = '';
          this.$set(this.localStep, 'input_type', field.inputType);
          this.stepRefreshIndex = this.localStep.keyIndex;
          setTimeout(() => {
            this.stepRefreshIndex = '';
          }, 100);
        } else {
          this.$set(this.localStep, 'input_type', '');
          this.$set(this.localStep, 'operator', '');
        }
      },
      openDTableModal() {
        this.dataTableMappingFields = this.getFieldProperty(
          this.actionEntityFields[this.localStep.entity_id],
          this.localStep.update_field,
          'key',
          'data_table_columns'
        );
        if (this.localStep['data_table_mapping']) {
          this.dataTableMapping = { ...this.localStep.data_table_mapping };
        } else {
          this.dataTableMapping = {};
        }
        this.mapDataTableFieldsModal = true;
      },
      tableFieldDisabled(field) {
        if (
          field.data_table_field_index &&
          field.data_table_field_index > -1 &&
          Object.keys(this.actionEntityPrimaryFieldsMap).find((e) => e.includes('relation/')) !==
            undefined
        ) {
          return true;
        } else {
          return false;
        }
      },
      saveDataTableConfig() {
        this.$set(this.localStep, 'data_table_mapping', this.dataTableMapping);
        this.mapDataTableFieldsModal = false;
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 1rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    color: #374151;
    transition: all 0.2s ease;
  }

  .action-config-item .el-select,
  .action-config-item .el-button,
  .action-config-item .el-checkbox {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .action-config-item .el-select .el-input__inner {
    border-radius: 6px;
  }

  .action-config-item .el-button {
    border-radius: 6px;
    background-color: #2563eb;
    color: white;
    font-weight: 500;
    padding: 0.35rem 0.75rem;
    transition: background-color 0.2s;
  }

  .action-config-item .el-button:hover {
    background-color: #1d4ed8;
  }

  .action-config-item .d-flex {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }

  .el-tooltip .item {
    font-size: 0.85rem;
  }

  .el-input input {
    border-radius: 6px;
    padding: 0.35rem 0.5rem;
    font-size: 0.95rem;
  }

  .el-select .el-select-dropdown__item {
    font-size: 0.95rem;
  }

  .el-select .el-select-dropdown__item:hover {
    background-color: #eff6ff;
  }

  .el-button[type='text'] {
    color: #2563eb;
    font-weight: 500;
  }

  .el-button[type='text']:hover {
    color: #1d4ed8;
    background-color: #e0f2fe;
  }
</style>
